/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingPlanConfiguration {
    getFixupPrototypeFunction() { return BillingPlanConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BillingPlanConfiguration>): BillingPlanConfiguration {
        let obj = Object.assign(new BillingPlanConfiguration(), model);
        BillingPlanConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingPlanConfiguration>): BillingPlanConfiguration {
        if (!model) return null;
        return BillingPlanConfiguration.newInstance(<BillingPlanConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingPlanConfiguration) {
        if (!obj) return;

        models.BillingPlanConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingPlanConfiguration): boolean {
        Object.setPrototypeOf(obj, BillingPlanConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.rules) {
            for (let val of this.rules) {
                models.BillingRuleRoot.fixupPrototype(val);
            }
        }
    }

    /**
     * Root rule of the billing plan. This rule is used to evaluate the billing plan.
     */
    rules: Array<models.BillingRuleRoot>;

}
